import CommunityAbout from '../assets/community-about.png';
import CommunityBannerMobile from '../assets/community-banner-mobile.png';
import CommunityBanner from '../assets/community-banner.png';
import { Layout } from '../components/page-layout';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;
const Centered = styled.div`
  text-align: center;
`;
const MainTitle = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  color: #F87B15;
  margin-bottom: 0.5rem;
`;
const MainDesc = styled.div`
  font-size: 18px;
  color: #7A7A7A;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
`;
const BannerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  @media (min-width: 768px) {
    height: 217px;
  }
`;
const BannerImgMobile = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  @media (min-width: 768px) {
    display: none;
  }
`;
const BannerImgDesktop = styled.img`
  display: none;
  @media (min-width: 768px) {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
const BannerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 1.5rem;
  color: #fff;
`;
const OverlayTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: bold;
  color: #fff;
`;
const OverlayText = styled.p`
  font-size: 0.875rem;
  margin-top: 3 rem;
  color: #fff;
  line-height: 0.5;
`;
const OverlayButton = styled.a`
  display: inline-block;
  background: #fff;
  color: #F87B15;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  border-radius: 0.5rem;
  text-decoration: none;
  font-weight: 500;
`;
const Section = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;
const FlexRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
const LeftCol = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 50%;
  }
`;
const RightCol = styled.div`
  width: 100%;
  margin-top: 3rem;
  @media (min-width: 768px) {
    width: 50%;
    margin-top: 0;
  }
`;
const StatRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StatCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StatNum = styled.span`
  font-size: 2.5rem;
  font-weight: bold;
  color: #F87B15;
`;
const StatLabel = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
`;
const StatDivider = styled.div`
  width: 1px;
  height: 3rem;
  background: #d1d5db;
  margin: 0 1.5rem;
`;
const AboutTitle = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  color: #F87B15;
  margin-bottom: 1rem;
`;
const AboutDesc = styled.p`
  color: #7A7A7A;
  margin-bottom: 2rem;
`;
const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const AboutImg = styled.img`
  width: 280px;
  height: auto;
  object-fit: cover;
  margin: 0 auto;
  display: block;
`;
const CommunityTitle = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  color: #F87B15;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
`;
const CommunityDesc = styled.p`
  color: #6b7280;
  margin-bottom: 2rem;
`;

export default function Community() {
  return (
    <Layout showCommonFooter={true}>
      <Container>
        {/* 标题和描述 */}
        <Centered>
          <MainTitle>Community</MainTitle>
          <MainDesc>
            Sensforge is for parents, pet owners, and smart home enthusiasts who
            want to capture life&apos;s moments. Stay connected, relive
            memories,<br />
            and enhance your home experience with smart technology. Connect,
            share knowledge, and shape innovation as we evolve together.
          </MainDesc>
        </Centered>
        {/* 图片和覆盖内容 */}
        <BannerWrapper>
          <BannerImgMobile
            src={CommunityBannerMobile}
            alt="Community Banner Mobile"
          />
          <BannerImgDesktop
            src={CommunityBanner}
            alt="Community Banner"
          />
          <BannerOverlay>
            <OverlayTitle>Join Now</OverlayTitle>
            <OverlayText>Join Sensforge by filling out</OverlayText>
            <OverlayText>
              your details and connect with innovators.
            </OverlayText>
            <OverlayButton
              href="https://www.facebook.com/groups/sensforgecorecommunity"
            >
              Join Core Community
            </OverlayButton>
          </BannerOverlay>
        </BannerWrapper>
        <Section>
          <FlexRow>
            <LeftCol>
              <Centered>
                <AboutTitle>About Sensforge</AboutTitle>
                <AboutDesc>
                  From home security cameras to wearable devices for activities
                  like walking your dog, Sensforge products are designed to keep
                  you connected and in the moment. With low-power chips and
                  real-time updates, we ensure you never miss anything
                  important. And by bringing manufacturing in-house, we can
                  rapidly iterate to deliver the best possible experience.
                </AboutDesc>
                <StatRow>
                  <StatCol>
                    <StatNum>10+</StatNum>
                    <StatLabel>Ongoing products</StatLabel>
                  </StatCol>
                  <StatDivider />
                  <StatCol>
                    <StatNum>20+</StatNum>
                    <StatLabel>Implementations</StatLabel>
                  </StatCol>
                </StatRow>
              </Centered>
            </LeftCol>
            <RightCol>
              <ImgWrapper>
                <AboutImg src={CommunityAbout} alt="Community About" />
              </ImgWrapper>
              <Centered>
                <CommunityTitle>About Sensforge Community</CommunityTitle>
                <CommunityDesc>
                  Connect with innovators, share insights, and stay ahead of
                  industry trends. Be part of a network that thrives on
                  collaboration and growth.
                </CommunityDesc>
              </Centered>
            </RightCol>
          </FlexRow>
        </Section>
      </Container>
    </Layout>
  );
}
